const defaultState = {
  invoice: null,
  client: null,
  title: null,
  selectedDrawerItem: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'EDIT_ADMIN':
      return {...state, ...action.updates};
      //return Object.assign({}, state, action.updates);
    case 'SET_ADMIN':
      return action.admin;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/admin.js